import { useSplitEnabled } from '@buffer-mono/features'

export function useShouldShowMocktail(): boolean {
  const { isEnabled } = useSplitEnabled('show-mocking-devtool')

  return isEnabled
}
